import { useMemo } from 'react';

import { useUserContext } from '~/utilities/context/dynamic/UserContext';
import { useStaticContext } from '~/utilities/context/static/StaticContext';
import type { Price } from '~/utilities/graphql/codegen';
import { CustomerType } from '~/utilities/graphql/codegen';

interface ParamType {
  personalisedPrice?: Price | null | number;
  styleVariantPersonalisedPrice?: string | number | null;
}
interface ReturnType {
  applyPersonalisedPrice: boolean;
  updatePersonalisedSignings: boolean;
  updateSigningForGuests: boolean;
  membersOnlyPriceEnabled?: boolean | null;
}

export const useMembersOnlyInformation = ({
  personalisedPrice,
  styleVariantPersonalisedPrice,
}: ParamType): ReturnType => {
  const {
    configuration: { membersOnlyPriceEnabled },
  } = useStaticContext();
  const { user } = useUserContext();
  const personalisedPricePassed = Boolean(personalisedPrice);

  return useMemo(() => {
    const isLoggedIn = user?.customerType === CustomerType.Registered;
    const hasProductMOData = Boolean(personalisedPricePassed && membersOnlyPriceEnabled);
    const hasStyleVariantMOData = Boolean(styleVariantPersonalisedPrice && membersOnlyPriceEnabled);

    const applyPersonalisedPrice = isLoggedIn && hasProductMOData;
    const updatePersonalisedSignings = !isLoggedIn && hasProductMOData;
    const updateSigningForGuests = !isLoggedIn && hasStyleVariantMOData;

    return {
      applyPersonalisedPrice,
      updatePersonalisedSignings,
      updateSigningForGuests,
      membersOnlyPriceEnabled,
    };
  }, [
    membersOnlyPriceEnabled,
    personalisedPricePassed,
    styleVariantPersonalisedPrice,
    user?.customerType,
  ]);
};
